/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const BY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1000"
    height="600"
    viewBox="0 0 1000 600"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 0h1000v600H0z"
    />
    <path
      fill="#0098d4"
      d="M963.5625 0H742.375L1000 570v30H792.375L521.1875 0H300l271.1875 600H350L150 157.5 0 119.25V315l128.8125 285H350L0 510.75V315l1000 255V374.25L150 157.5 78.8125 0H300l700 178.5V80.625z"
    />
  </svg>
);
export default memo(BY);
